//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'vant'
export default {
  name: 'MergeTable',
  props: {
    data: { type: Array, default: () => [] },
    baseMergeKey: { type: String, default: '' },
    mergeKeys: { type: Array, default: () => [] },
    /** 自定义合并：(data, columns) => spanMap，与 PC span-method 对齐时使用 */
    spanMapFn: { type: Function, default: null },
    columns: { type: Array, required: true },
    pagination: Boolean,
    total: { type: Number, default: 0 },
  },
  data() {
    return {
      pageIndex: 1,
      // 滚动相关数据
      scrollPosition: 0,
      startX: 0,
      startY: 0,
      startTime: 0,
      lastX: 0,
      lastTime: 0,
      velocity: 0,
      isScrolling: false,
      isDecelerating: false,
      animationFrame: null,
      
      // 滚动边界
      minScroll: 0,
      maxScroll: 0,
      
      // 滚动指示器
      showScrollIndicator: false,
      indicatorWidth: 0,
      
      // toast配置
      toastContent: '',
      toastDuration: 0 // 0表示不自动关闭
    }
  },
  computed: {
    // 过滤显示的列，支持show为函数或布尔值
    filterColumns() {
      return this.columns.filter(col => {
        if (typeof col.show === 'function') {
          return col.show()
        }
        return col.show !== false
      })
    },
    indicatorStyle() {
      const containerWidth = this.$refs.tableContainer ? this.$refs.tableContainer.offsetWidth : 0
      const contentWidth = this.maxScroll - this.minScroll
      if (contentWidth <= 0) return { display: 'none' }
      
      const scrollRatio = containerWidth / contentWidth
      const positionRatio = -this.scrollPosition / contentWidth
      
      return {
        width: `${Math.max(scrollRatio * 100, 10)}%`,
        transform: `translateX(${positionRatio * 100}%)`
      }
    },
    
    spanMap() {
      if (typeof this.spanMapFn === 'function') {
        return this.spanMapFn(this.data, this.filterColumns) || {}
      }
      const map = {};
      const { data, baseMergeKey, mergeKeys, filterColumns } = this;

      /* 1. 先按 baseMergeKey 分段 */
      const segments = [];
      let i = 0;
      while (i < data.length) {
        const val = data[i][baseMergeKey];
        let j = i + 1;
        while (j < data.length && data[j][baseMergeKey] === val) j++;
        segments.push({ start: i, end: j - 1, len: j - i });
        i = j;
      }

      /* 2. 每一段内部再处理 mergeKeys 里的字段 */
      segments.forEach(seg => {
        mergeKeys.forEach(prop => {
          let k = seg.start;
          while (k <= seg.end) {
            const val = data[k][prop];
            let m = k + 1;
            while (m <= seg.end && data[m][prop] === val) m++;
            const rowspan = Math.min(m - k, seg.len);
            for (let n = k; n < m; n++) {
              if (!map[n]) map[n] = {};
              map[n][prop] = { rowspan, show: n === k };
            }
            k = m;
          }
        });
      });

      /* 3. 非 mergeKeys 字段默认 rowspan=1 */
      filterColumns.forEach(col => {
        if (mergeKeys.includes(col.prop) || col.prop === baseMergeKey) return;
        data.forEach((_, idx) => {
          if (!map[idx]) map[idx] = {};
          map[idx][col.prop] = { rowspan: 1, show: true };
        });
      });

      return map;
    }
  },
  watch: {
    data: {
      handler() {
        this.$nextTick(() => {
          this.calculateScrollBoundaries()
          this.showScrollIndicator = this.maxScroll < this.minScroll
        })
      },
      deep: true,
      immediate: true
    },
    pageIndex(newPage) {
      this.loadTableData()
    }
  },
  mounted() {
    this.calculateScrollBoundaries()
    this.showScrollIndicator = this.maxScroll < this.minScroll
  },
  beforeDestroy() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame)
    }
  },
  methods: {
    getBodyClass (row, col) {
      const parts = []
      if (col.bodyClass) parts.push(col.bodyClass)
      if (typeof col.bodyClassFn === 'function') {
        const extra = col.bodyClassFn(row, col)
        if (extra) parts.push(extra)
      }
      return parts.join(' ')
    },
    colHeader (col) {
      if (!col) return { text: '', required: false }
      if (col.required) {
        return { text: col.label || '', required: true }
      }
      const label = col.label
      if (typeof label === 'string' && label.length > 0 && label.charAt(label.length - 1) === '*') {
        return { text: label.slice(0, -1), required: true }
      }
      return { text: label, required: false }
    },
    // 计算滚动边界
    calculateScrollBoundaries() {
      if (!this.$refs.tableContainer) return
      
      this.$nextTick(() => {
        const container = this.$refs.tableContainer
        const content = container.querySelector('.data-box')
        
        if (container && content) {
          const containerWidth = container.offsetWidth
          const contentWidth = content.scrollWidth
          
          this.minScroll = Math.min(0, containerWidth - contentWidth)
          this.maxScroll = 0
          
          // 限制当前位置在边界内
          this.scrollPosition = Math.max(this.minScroll, Math.min(this.maxScroll, this.scrollPosition))
        }
      })
    },
    
    // 触摸开始
    handleTouchStart(e) {
      if (this.isDecelerating) {
        this.stopDeceleration()
      }
      
      this.isScrolling = true
      this.startX = e.touches[0].clientX
      this.startY = e.touches[0].clientY
      this.startTime = Date.now()
      this.lastX = this.startX
      this.lastTime = this.startTime
      this.velocity = 0
    },
    
    // 触摸移动 - 优化滑动速度
    handleTouchMove(e) {
      if (!this.isScrolling) return
      
      const touchX = e.touches[0].clientX
      const touchY = e.touches[0].clientY
      const deltaX = touchX - this.startX
      const deltaY = touchY - this.startY
      
      // 判断滑动方向（增加角度容差）
      if (Math.abs(deltaX) > Math.abs(deltaY) * 0.7) {
        // 不可取消时（如页面滚动中）禁止 preventDefault，否则会触发 Chrome [Intervention] 警告
        if (e.cancelable) {
          e.preventDefault()
        }
        e.stopPropagation()
        
        const now = Date.now()
        const deltaTime = now - this.lastTime
        
        if (deltaTime > 0) {
          // 计算速度（像素/毫秒）
          this.velocity = (touchX - this.lastX) / deltaTime
          this.lastX = touchX
          this.lastTime = now
        }
        
        // 直接应用位移，增加灵敏度系数
        const sensitivity = 1.2 // 增加灵敏度
        let newPosition = this.scrollPosition + deltaX * sensitivity
        
        // 应用边界弹性效果
        newPosition = this.applyBoundaries(newPosition, true)
        
        this.scrollPosition = newPosition
        this.startX = touchX
        
        this.showScrollIndicator = true
      }
    },
    
    // 触摸结束 - 添加惯性滚动
    handleTouchEnd() {
      if (!this.isScrolling) return
      
      this.isScrolling = false
      
      // 如果速度足够大，启动惯性滚动
      if (Math.abs(this.velocity) > 0.1) {
        this.startDeceleration()
      } else {
        this.snapToBoundary()
      }
      
      // 3秒后隐藏滚动指示器
      setTimeout(() => {
        this.showScrollIndicator = false
      }, 3000)
    },
    
    // 应用边界效果（带弹性）
    applyBoundaries(position, isDragging = false) {
      if (position > this.maxScroll) {
        // 超过右边界 - 弹性效果
        const overshoot = position - this.maxScroll
        return this.maxScroll + overshoot * 0.3
      } else if (position < this.minScroll) {
        // 超过左边界 - 弹性效果
        const overshoot = position - this.minScroll
        return this.minScroll + overshoot * 0.3
      }
      return position
    },
    
    // 惯性滚动
    startDeceleration() {
      this.isDecelerating = true
      const friction = 0.92 // 摩擦系数，值越小停止越快
      const minVelocity = 0.1 // 最小速度阈值
      
      const animate = () => {
        if (!this.isDecelerating) return
        
        // 应用速度
        this.velocity *= friction
        let newPosition = this.scrollPosition + this.velocity * 16 // 16ms一帧
        
        // 应用边界和弹性
        newPosition = this.applyBoundaries(newPosition)
        
        this.scrollPosition = newPosition
        
        // 检查是否需要停止
        if (Math.abs(this.velocity) < minVelocity || 
            (this.scrollPosition >= this.maxScroll && this.velocity > 0) ||
            (this.scrollPosition <= this.minScroll && this.velocity < 0)) {
          this.stopDeceleration()
          this.snapToBoundary()
        } else {
          this.animationFrame = requestAnimationFrame(animate)
        }
      }
      
      this.animationFrame = requestAnimationFrame(animate)
    },
    
    // 停止惯性滚动
    stopDeceleration() {
      this.isDecelerating = false
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame)
        this.animationFrame = null
      }
    },
    
    // 吸附到边界
    snapToBoundary() {
      const snapThreshold = 50 // 吸附阈值
      
      if (this.scrollPosition > this.maxScroll - snapThreshold) {
        this.animateTo(this.maxScroll)
      } else if (this.scrollPosition < this.minScroll + snapThreshold) {
        this.animateTo(this.minScroll)
      }
    },
    
    // 平滑动画到指定位置
    animateTo(targetPosition, duration = 300) {
      const startPosition = this.scrollPosition
      const startTime = Date.now()
      
      const animate = () => {
        const currentTime = Date.now()
        const elapsed = currentTime - startTime
        const progress = Math.min(elapsed / duration, 1)
        
        // 使用缓动函数
        const easeProgress = this.easeOutCubic(progress)
        this.scrollPosition = startPosition + (targetPosition - startPosition) * easeProgress
        
        if (progress < 1) {
          this.animationFrame = requestAnimationFrame(animate)
        }
      }
      
      this.animationFrame = requestAnimationFrame(animate)
    },
    
    // 缓动函数
    easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3)
    },
    
    getSpan(row, prop) {
      const idx = this.data.indexOf(row)
      const map = this.spanMap[idx]
      if (!map || !map[prop]) {
        return { rowspan: 1, show: true }
      }
      return map[prop]
    },
    
    loadTableData() {
      this.$emit('loadTableData', this.pageIndex)
    },
    
    // 显示单元格内容的Toast
    showCellToast(row, col, idx) {
      let content = ''
      
      if (col.formatter) {
        content = col.formatter(row[col.prop], row, idx) || ''
      } else if (col.precision != null) {
        content = Number(row[col.prop]).toFixed(col.precision) || ''
      } else {
        content = row[col.prop] || ''
      }
      
      Toast({
        message: content,
        closeOnClick: true,
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/srm/pendingApproval/components/MergeTable.vue